module.exports = __webpack_public_path__ + "static/index/img/baikal-405.30c4de4a.jpg";